import React from 'react';
import PropTypes from 'prop-types';
import pageLoadingIndicator from '@mapbox/mr-ui/page-loading-indicator';
import {
  addRouteChangeStartListener,
  addRouteChangeEndListener
} from '@mapbox/batfish/modules/route-change-listeners';
import { AppContext } from '../context.js';

if (typeof window !== 'undefined') {
  import(
    /* webpackChunkName: "assembly-js" */ '@mapbox/mbx-assembly-docs/dist/assembly.js'
  );
}

addRouteChangeStartListener(() => {
  pageLoadingIndicator.start();
});
addRouteChangeEndListener(() => {
  pageLoadingIndicator.end();
});

class ApplicationWrapper extends React.PureComponent {
  setUser = (user) => {
    this.setState({ userName: user });
  };

  state = {
    platform: 'iOS',
    languages: {
      ios: [
        {
          label: 'Swift',
          value: 'swift'
        },
        {
          label: 'Objective-C',
          value: 'objectiveC'
        }
      ]
    },
    preferredLanguage: {
      ios: 'swift'
    },
    changeLanguage: {
      ios: (nextLang) => {
        this.setState({
          preferredLanguage: {
            ...this.state.preferredLanguage,
            ios: nextLang
          }
        });
      }
    },
    userAccessToken: undefined,
    userName: undefined,
    updateUser: this.setUser
  };

  constructor(props) {
    super(props);
    this.changeLanguage = (nextLang) => {
      this.setState({ preferredLanguage: nextLang });
    };
  }

  componentDidMount() {
    MapboxPageShell.afterUserCheck(() => {
      this.setState(
        {
          user: MapboxPageShell.getUser() || undefined
        },
        () => {
          this.updateAuthenticatedUser();
        }
      );
    });
  }

  updateAuthenticatedUser = () => {
    if (typeof this.state.user === 'undefined') {
      return;
    } else {
      this.state.updateUser(this.state.user.id);
    }
  };

  render() {
    return (
      <AppContext.Provider value={{ ...this.state }}>
        {this.props.children}
      </AppContext.Provider>
    );
  }
}
ApplicationWrapper.propTypes = {
  children: PropTypes.node
};

export default ApplicationWrapper;
